// a reducer takes in two things:
// 1. the action (info about what happened)
// 2. a copy of the current state
import { combineReducers } from 'redux'
import update from 'immutability-helper'
import { v4 as uuidv4 } from 'uuid'
import { createTransform, persistReducer } from 'redux-persist'
import sessionStorage from 'redux-persist/lib/storage/session'

// Redux-persist stringify's items prior to storing them.  Dates need to be transformed back into appropriate types
const dateTransform = createTransform(
    null,
    (state) => {
        return {
            ...state,
            endDate: state.endDate ? new Date(state.endDate) : null,
            startDate: state.startDate ? new Date(state.startDate) : null,
        }
    },
    {},
)

// Explicitly persisting only the jobListFilter's by whitelisting them
const persistConfig = {
    key: 'jobListFilter',
    storage: sessionStorage,
    whitelist: ['jobListFilter'],
    transforms: [dateTransform],
}

function cloudJob(state = [], action) {
    switch (action.type) {
        case 'SET_CLOUD_JOB':
            return update(state, {
                $set: action.cloudJob,
            })
        default:
            return state
    }
}

function workorderName(state = [], action) {
    switch (action.type) {
        case 'SET_WORK_ORDER_NAME':
            return update(state, {
                $set: action.workorderName,
            })
        default:
            return state
    }
}

function originationId(state = [], action) {
    switch (action.type) {
        case 'SET_ORIGINATION_ID':
            return update(state, {
                $set: action.originationId,
            })
        default:
            return state
    }
}

function isFetching(state = true, action) {
    switch (action.type) {
        case 'SELECT_COMPANY':
            return true
        case 'RECEIVE_WORK_ORDERS':
            return false
        case 'SET_JOB_LIST_FILTER':
            return true
        default:
            return state
    }
}

function workorders(state = [], action) {
    let index
    switch (action.type) {
        case 'DISPATCH_TO_IN_PROGRESS':
            return update(state, {
                $set: action.workorder,
            })
        case 'RECEIVE_WORK_ORDERS':
            return update(state, {
                $set: action.workorders,
            })
        case 'UPDATE_WORK_ORDER':
            index = state.findIndex(wo => { return wo.id === action.workorder.id || wo.guid === action.workorder.guid })
            if (index === -1) {
                return update(state, {
                    $push: [action.workorder],
                })
            }
            // remove the old element and insert the updated one

            return update(state, {
                $splice: [[index, 1,
                    update(state[index], {$merge: action.workorder}),
                ]],
            })
        case 'DELETE_WORK_ORDER':
            index = state.findIndex(wo => { return wo.id === action.workorder.id || wo.guid === action.workorder.guid })
            if (index === -1) {
                return state
            }

            return update(state, {
                $splice: [[index, 1]],
            })
        default:
            return state
    }
}

function workorderUuid(state = [], action) {
    switch (action.type) {
        case 'SET_WORK_ORDER_UUID':
            return update(state, {
                $set: action.workorderUuid,
            })
        case 'GENERATE_WORK_ORDER_UUID':
            return update(state, {
                $set: uuidv4(),
            })
        default:
            return state
    }
}

function filteredJobs(state = [], action) {
    switch (action.type) {
        case 'SET_FILTERED_JOBS':
            return update(state, {
                $set: action.filteredJobs,
            })
        case 'SELECT_COMPANY':
            return []
        case 'SET_JOB_LIST_FILTER':
            return []
        default:
            return state
    }
}

function jobListFilter(state = {}, action) {
    const jobListFilter = action.filter
    switch (action.type) {
        case 'SET_JOB_LIST_FILTER':
            if (jobListFilter.filteredJobs) delete jobListFilter.filteredJobs
            if (jobListFilter.sortedJobs) delete jobListFilter.sortedJobs

            return update(state, {
                $set: jobListFilter,
            })
        default:
            return state
    }
}

export const defaultWorkorder = {
    cloudJob: true,
    isFetching: true,
    filteredJobs: [],
    workorderName: '',
    originationId: 'PORTAL',
    workorders: [],
    workorderUuid: '',
    jobListFilter: {
        endDate: null,
        startDate: null,
        selectedDateConstant: 0,
        selectedAvailability: 0,
        selectedParticipantActivity: 'all',
        selectedGrowers: [],
        selectedFarms: [],
        selectedFields: [],
        noGFFonly: false,
        selectedMixes: [],
        selectedSystems: [],
        selectedCompanyId: 0,
        sortOrder: 0,
        jobName: '',
        error: {value: ''},
    },
}
const workorderReducer = combineReducers({
    cloudJob,
    isFetching,
    filteredJobs,
    workorderName,
    originationId,
    workorders,
    workorderUuid,
    jobListFilter,
})
const persistedReducer = persistReducer(persistConfig, workorderReducer)

export default persistedReducer
